import "./BackgroundSelector.css";
import ZoomModal from "../../components/ZoomModal/ZoomModal";
import BackgroundSelectorDesktopView from "../../components/BackgroundSelectorDesktopView/BackgroundSelectorDesktopView";
import BackgroundSelectorMobileView from "../../components/BackgroundSelectorMobileView/BackgroundSelectorMobileView";
import { useBackgroundSelector } from "../../customHook/BackgroundSelector/useBackgroundSelector";
import { useIsMobile } from "../../customHook/common/useIsMobile";

export default function BackgroundSelector({
  selectedProduct,
  selectedModel,
  selectedBackgroundImage,
  setSelectedBackgroundImage,
  setStep,
  step,
  backgroundsData,
  onRefreshBackgrounds,
  isLoading,
  pagination,
  onSearchCommit,
  onPageChange,
}) {
  const {
    searchTerm,
    onSearchChange,
    filteredBackgrounds,
    modal,
    openModal,
    closeModal,
  } = useBackgroundSelector(selectedProduct, backgroundsData, onSearchCommit);
  const isMobile = useIsMobile();

  const handleSkipBackground = () => {
    setSelectedBackgroundImage(null);
    setStep(step + 1);
  };

  const handleRefreshBackgrounds = async () => {
    if (onRefreshBackgrounds) {
      onRefreshBackgrounds();
    }
  };

  return (
    <>
      <div className="background-selector flex-1 flex flex-col min-h-0 overflow-hidden">
        {isMobile ? (
          <BackgroundSelectorMobileView
            openModal={openModal}
            filteredData={filteredBackgrounds}
            searchTerm={searchTerm}
            onSearchChange={onSearchChange}
            setStep={setStep}
            step={step}
            selectedBackgroundImage={selectedBackgroundImage}
            setSelectedBackgroundImage={setSelectedBackgroundImage}
            selectedProduct={selectedProduct}
            selectedModel={selectedModel}
            onSkip={handleSkipBackground}
            onRefreshBackgrounds={handleRefreshBackgrounds}
            isLoading={isLoading}
            pagination={pagination}
            onPageChange={onPageChange}
          />
        ) : (
          <BackgroundSelectorDesktopView
            filteredData={filteredBackgrounds}
            searchTerm={searchTerm}
            onSearchChange={onSearchChange}
            openModal={openModal}
            setStep={setStep}
            step={step}
            selectedModel={selectedModel}
            selectedBackgroundImage={selectedBackgroundImage}
            setSelectedBackgroundImage={setSelectedBackgroundImage}
            selectedProduct={selectedProduct}
            onSkip={handleSkipBackground}
            onRefreshBackgrounds={handleRefreshBackgrounds}
            isLoading={isLoading}
            pagination={pagination}
            onPageChange={onPageChange}
          />
        )}
      </div>

      <ZoomModal
        modalId="modelZoomModal"
        front={modal.front}
        onClose={closeModal}
        showFlip={false}
        isBackground={true}
      />
    </>
  );
}
